import { NavigateFunction } from 'react-router'

import { Organization } from '@modules-deprecated/app/organization/types/organization'

import { queryClient } from '../../../config/queryClient'
import { QueryKeys } from '../../../enums/queryKeys'
import { getEInvoicesUrl } from './getEInvoicesUrl'

export const navigateToUploadsUrl = async (organization: Organization, navigate: NavigateFunction) => {
  await queryClient.invalidateQueries(QueryKeys.EInvoicingGetKYCStatus)
  navigate(getEInvoicesUrl(organization))
}
